module.exports = {
  SEARCH: 'SEARCH',
  SELECT_TAB: 'SELECT_TAB',
  CLEAR_FILTER: 'CLEAR_FILTER',
  TRACK_AND_TRACE: 'TRACK_AND_TRACE',
  UPDATE_SELECTED_CATEGORY_FILTERS: 'UPDATE_SELECTED_CATEGORY_FILTERS',
};
